import { render, staticRenderFns } from "./ReferralToView.vue?vue&type=template&id=b3b0a6f4&"
import script from "./ReferralToView.vue?vue&type=script&lang=ts&"
export * from "./ReferralToView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports